import React from 'react';
import { UserManagementPage } from './UserManagement';

const MerchantManagement: React.FC = () => <UserManagementPage mode="merchant" />;

export default MerchantManagement;
